import { NgModule } from '@angular/core';
import { RelativeDatePipe } from './relative-date.pipe';
import { RelativeDateService } from './relative-date.service';

@NgModule({
    declarations: [RelativeDatePipe],
    exports: [RelativeDatePipe],
    providers: [RelativeDateService],
})
export class FiRelativeDateModule {}
